import { StepType } from '@ibe/services';
import { CheckoutStep } from '../../Models/CheckoutStep';
import { ImageProgressbarStep } from '@ibe/components';

export function getAvailableSteps(allSteps: CheckoutStep[], filterExtras: boolean): CheckoutStep[] {
  if (filterExtras) {
    return allSteps.filter(step => step.type !== StepType.OAG_CHECKOUT_EXTRAS);
  }
  return allSteps;
}

export function getAvailableTranslatedSteps(
  allSteps: ImageProgressbarStep[],
  filterExtras: boolean
): ImageProgressbarStep[] {
  if (filterExtras) {
    return allSteps.filter(step => step.description !== 'extras');
  }
  return allSteps;
}
